import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-if.js';

class KeliLookupItem extends PolymerElement {
  static get template() {
    return html`
<style>
  :host {
    display: block;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 8px 4px;
    border-left: 2px solid transparent;
    color: var(--keli-text);
  }

  @media (min-width: 800px) {
    :host {
      padding: 2px 4px;
    }
  }

  :host(.selected) {
    border-left-color: var(--keli-subtle-active-border);
    background-color: var(--keli-subtle-active-background) !important;
    color: var(--keli-subtle-active-color);
  }

  :host(.selected) #hint {
    color: var(--keli-subtle-active-color);
  }

  :host(:hover) {
    background-color: var(--keli-action-hover-background);
  }
  
  #caption {
    display: flex;
    align-items: center;
  }

  #hint {
    font-size: .8em;
    margin-left: .5em;
    font-weight: 300;
    color: var(--keli-text-subtle);
  }
  
  sl-icon {
    font-size: 16px;
    margin-right: 3px;
  }
</style>

<div id="caption">
  <template is="dom-if" if="[[formattedIcon]]"><sl-icon name="[[formattedIcon]]"></sl-icon></template>
  [[caption]]
  <template is="dom-if" if="[[formattedHotkey]]"> – [[formattedHotkey]]</template>
</div>
<div id="hint">[[hint]]</div>`;
  }

  static get is() {
    return 'keli-lookup-item';
  }

  static get properties() {
    return {
      caption: String,
      chooseAction: String,
      formattedHotkey: {type: String, computed: 'computeFormattedHotkey(hotkey)'},
      hint: String,
      hotkey: String,
      formattedIcon: {type: String, computed: 'computeFormattedIcon(icon)'},
      icon: String,
      lookup: Object,
      rowId: String,
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.handleClick);
    this.lookup = null;
  }

  computeFormattedHotkey(hotkey) {
    if (KeliInterface.isTouchDevice) {
      return;
    }
    if (hotkey) {
      return formatHotkeyAsText(hotkey);
    }
  }

  computeFormattedIcon(icon) {
    return KeliInterface.Styles.parseIconName(icon);
  }

  handleClick(event) {
    event.preventDefault();
    this.activate(event, true);
  }

  activate(event, focusInput) {
    if (event instanceof MouseEvent) {
      event.stopPropagation();
    }

    if (!this.lookup) {
      return;
    }
    this.lookup.dispatchEvent(new CustomEvent('lookupChooseItem', {
      detail: {
        element: this,
        event: event,
        focusInput: focusInput
      }
    }));
  }
}

customElements.define(KeliLookupItem.is, KeliLookupItem);
export {KeliLookupItem};
